import { render } from "./salaries.vue?vue&type=template&id=49c44ec6"
import script from "./salaries.vue?vue&type=script&lang=js"
export * from "./salaries.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__